import React, { FC, useState, useEffect, ChangeEvent } from 'react';
import { TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import { reduxActions, useDispatch } from 'store';
import { IDynamicUiField } from 'plugins/api/types';

interface IProps {
  field: IDynamicUiField;
  pageSymbol: string;
  componentSymbol: string;
}

const textAreaSx: SxProps<Theme> = {
  '& .MuiInputLabel-root': { lineHeight: 1 },
  '& .MuiInputLabel-root.Mui-focused': { lineHeight: 'normal' },
  '& .MuiOutlinedInput-root': {
    alignItems: 'flex-start',
    borderRadius: '4px'
  },
  '& .MuiInputBase-inputMultiline': {
    padding: '12px 14px',
    borderRadius: '4px'
  }
};

const DynamicTextArea: FC<IProps> = ({ field, pageSymbol, componentSymbol }) => {
  const dispatch = useDispatch();

  const [value, setValue] = useState<string>((field.value as string) || '');

  useEffect(() => {
    setValue(field.value as string);
  }, [field.value]);

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(
      reduxActions.setFieldValue({
        pageSymbol,
        componentSymbol,
        fieldName: field.field_symbol,
        fieldValue: e.target.value
      })
    );

    setValue(e.target.value);
  };

  return (
    <TextField
      fullWidth
      multiline
      minRows={3}
      maxRows={16}
      color="secondary"
      sx={textAreaSx}
      label={field.label}
      value={value}
      onChange={onChangeHandler}
      disabled={!field.editable}
      helperText={field.hint || undefined}
    />
  );
};

export default DynamicTextArea;
